<template>
  <!-- Trợ lý ảo AVA - AI Bot -->
  <div
    v-if="isShowAVAIcon"
    :id="isShowOnMainApp ? 'ava-main-app' : 'ava-in-noti'"
    class="ava-icon"
    ref="avaIcon"
    :style="mainStyle"
  >
    <div class="ava-content">
      <div class="ava-icon-img-container">
        <div class="ava-icon-img"></div>
      </div>
      <div class="off-ava-btn icon24 off-ava-icon" v-if="isShowIconClose" @click="hideAVAIcon($event)"></div>
    </div>
  </div>
</template>

<script>
import {getCurrentInstance, onMounted, ref} from 'vue';
import {useContextStore} from '@/stores/contextStore';
import {avaFunctionCalling} from './avaFunctionCalling';
import avaPlatformApi from '@/apis/avaPlatform/avaPlatformApi';
import {showError} from '@/commons/globalMessage';
import {useDbOptionStore} from '@/stores/dbOptionStore';

export default {
  props: {
    isShowBoxChat: {
      type: Boolean,
      default: false,
    },
    isShowIconClose: {
      type: Boolean,
      default: true,
    },
    isShowOnMainApp: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const {proxy} = getCurrentInstance();
    const width = ref(0);
    const height = ref(0);
    const isShowAVAIcon = ref(true);
    const contextStore = useContextStore();
    let context = contextStore.$state?.context;
    let user = contextStore.$state?.context?.user;
    let mainStyle = '';
    mainStyle = props.isShowOnMainApp ? 'position: fixed;right: 12px;bottom:  115px;' : '';
    const dbOptionStore = useDbOptionStore();

    const hideAVAIcon = event => {
      event.stopPropagation();
      isShowAVAIcon.value = false;
    };

    // Variables to store mouse positions
    var offsetX, offsetY;
    let isDragging = false;
    let isClick = false;
    let avaMainApp = null;

    onMounted(() => {
      avaMainApp = document.getElementById('ava-main-app');
      let avaChatBot = document.querySelector('.ava-icon-img');
      // Attach mouse events
      avaChatBot.addEventListener('mousedown', mouseDown);
    });

    // Function to handle mouse down event
    function mouseDown(e) {
      e.preventDefault();
      isClick = true;
      if (avaMainApp) {
        const rect = avaMainApp.getBoundingClientRect();
        offsetX = e.clientX - rect.right;
        offsetY = e.clientY - rect.bottom;
        document.addEventListener('mousemove', mouseMove);
      }
      document.addEventListener('mouseup', mouseUp);
    }

    // Function to handle mouse move event
    function mouseMove(e) {
      e.preventDefault();
      if (isClick) {
        isDragging = true;
        let x = e.clientX - offsetX;
        let y = e.clientY - offsetY;
        x = Math.min(window.innerWidth - 12, Math.max(0, x));
        y = Math.min(window.innerHeight - 12, Math.max(0, y));
        avaMainApp.style.right = window.innerWidth - x + 'px';
        avaMainApp.style.bottom = window.innerHeight - y + 'px';
      }
    }

    // Function to handle mouse up event
    function mouseUp() {
      if (!isDragging) {
        show();
      }
      isClick = false;
      isDragging = false;
      document.removeEventListener('mousemove', mouseMove);
      document.removeEventListener('mouseup', mouseUp);
    }

    const {
      cash_payment_receipt_report,
      budget_plan_report,
      change_property,
      show_unit_options,
      show_cash_grid_detail,
      reset_form_param,
      quick_add_dic_accounting_object,
      quick_add_dic_bank_info,
      quick_add_dic_budget_source,
      depreciation_fixed_assets,
      quick_transfer_account,
      create_transfer_activity,
      create_transfer_closing,
      create_transfer_receipt_clear,
      create_transfer_receipt_clear_month13,
      create_transfer_begining,
      create_transfer_budget_balance,
    } = avaFunctionCalling(proxy);

    /**
     * Hiển thị chatbot
     * Click icon gấu ava sẽ gọi hàm này
     * Tùy cách xử lý sẽ sử dụng async/await hoặc .then callback cho phù hợp với code js hiện tại dự án đang triển khai
     */
    const show = async () => {
      const me = proxy;

      //nếu init rồi thì hiển thị luôn
      //cờ _inited để đánh dấu đã khởi tạo chưa
      if (me._inited) {
        // lấy session ID mới khi F5 hoặc tắt đi bật lại để tránh lưu lịch sử vào đoạn chat trước đó
        window._aiBot._config.sessionId = me.$ms.commonFn.newGuid();
        await window._aiBot.show(); //hàm này do thư viện aib.js cung cấp
        return;
      }
      me._inited = true;

      let avaConnectInfoStr = context.AVAConnectInfo ? context.AVAConnectInfo : null;

      let avaConnectInfo = JSON.parse(avaConnectInfoStr);
      if (!avaConnectInfo) {
        avaConnectInfo = await refreshConnection();
      } else {
        // lấy session ID mới khi F5 hoặc tắt đi bật lại để tránh lưu lịch sử vào đoạn chat trước đó
        avaConnectInfo.sessionId = me.$ms.commonFn.newGuid();
      }

      //nên có và gán theo version của ứng dụng
      let el = document.createElement('script');
      el.src = `${avaConnectInfo.baseUrl}/avaLoader.js`;
      el.type = 'text/javascript';
      el.onload = async () => {
        try {
          customAiBotConfig(avaConnectInfo);
          let config = getAiBotConfig();
          for (let i in avaConnectInfo) {
            config[i] = avaConnectInfo[i];
          }

          //Khai báo hàm xử lý refresh token khi gặp lỗi 401
          config.refreshToken = refreshConnection;

          //Khai báo 1 số xử lý đặc thù của dự án nếu có
          //   config.fnAfterShow = me.fnAfterShow;
          //   config.fnAfterHide = me.fnAfterHide;
          config.fnAfterShow = () => {};
          config.fnAfterHide = () => {};
          // Hàm này trong aib.js
          window._aiBot = await window.initAiBot(config);

          //Chỉ định hàm xử lý nghiệp vụ
          //Sau khi phân tích được ý định của người dùng aibot sẽ gọi hàm này về dự án để xử lý nghiệp vụ
          window._aiBot.callJs = processBusiness;
          window._aiBot.customBotChatRender = customBotChatRender;
          window._aiBot.customItemRenderQuickReplies = customItemRenderQuickReplies;
          window._aiBot.itemClick = itemClick;
          window._aiBot.handleCustomQuickReplies = handleCustomQuickReplies;

          //hiển thị chatbot
          await window._aiBot.show();

          window._aiBot.openLiveChat = openLiveChat; // callback function để mở liveChat
          window._aiBot.customDataLiveChat = customDataLiveChat; // callback function để custom lại tham số LiveChat
        } catch (ex) {
          console.log(ex);
        }
      };

      document.head.appendChild(el);
    };

    /**
     * Mở  live chat
     * vqphong - 01/10/2024
     */
    const openLiveChat = data => {
      // Các dự án thực hiện mở livechat theo dự án đang làm các thông tin
      if (Object.keys(data).length > 0) {
        let sessionLiveChat = window.LiveChatWidget.get('customer_data');

        let fullname = user?.full_name ?? '';
        let email = user?.email ?? '';
        LiveChatWidget.call('set_customer_name', fullname);
        LiveChatWidget.call('set_customer_email', email);

        if (Object.keys(sessionLiveChat?.sessionVariables).length > 0) {
          window.LiveChatWidget.call('update_session_variables', {
            'Họ tên': fullname,
            'Mã ngân sách': context?.Context?.BudgetCode,
            'Phiên Chat MISA AVA': data.SessionId, //Mã phiên chat
            'Mã trợ lý số MISA AVA': data.AppId, //Mã trợ lý
            'Tên miền': '',
            Email: email,
            'Điện thoại': context?.Context?.Mobile,
            'Mã số thuế': dbOptionStore?.state?.CompanyTaxCode,
            'Tên đơn vị': context?.Context?.TenantName,
          });
        } else {
          window.LiveChatWidget.call('set_session_variables', {
            'Họ tên': fullname,
            'Mã ngân sách': context?.Context?.BudgetCode,
            'Phiên Chat MISA AVA': data.SessionId, //Mã phiên chat
            'Mã trợ lý số MISA AVA': data.AppId, //Mã trợ lý
            'Tên miền': '',
            Email: email,
            'Điện thoại': context?.Context?.Mobile,
            'Mã số thuế': dbOptionStore?.state?.CompanyTaxCode,
            'Tên đơn vị': context?.Context?.TenantName,
          });
        }

        window.LiveChatWidget.call('maximize');
        return true; // bắt buộc
      }

      return false; // bắt buộc
    };

    /**
     * Custom lại data truyền vào live chat
     * vqphong - 01/10/2024
     */
    const customDataLiveChat = data => {
      if (!window.LiveChatWidget || typeof window.LiveChatWidget.get !== 'function') {
        return data;
      }

      let chatData = window.LiveChatWidget.get('chat_data');
      let customerData = window.LiveChatWidget.get('customer_data');

      data.CustomerId = data.CustomerId ?? customerData?.id ? customerData?.id : '';
      data.ChatId = data.ChatId ?? chatData?.chatId ? chatData?.chatId : '';
      data.ThreadId = data.ThreadId ?? chatData?.threadId ? chatData?.threadId : '';

      return data;
    };

    /**
     * Xử lý refresh token của aichatbot
     */
    const refreshConnection = async () => {
      let data = await avaPlatformApi.refreshAVAConnect();
      if (data) {
        context.AVAConnectInfo = JSON.stringify(data);
        return data;
      } else {
        showError('Đã có lỗi xảy ra, vui lòng liên hệ MISA để được hỗ trợ.');
      }
    };
    /**
     * Xử lý nghiệp vụ khi nhận được từ
     * param {object}: Tham số này gồm 2 thuộc tính
     * 	- code {string}: mã hành động phân tích ra
     * 	- data {object}: dữ liệu kèm theo
     * Khuyến nghị tạo từng hàm theo code để xử lý
     */
    const processBusiness = param => {
      let fn = this[param.code];
      if (typeof fn !== 'function') {
        console.warn(`Thiếu hàm xử lý cho ${param.code}`);
        return;
      }

      fn(param.data);
    };
    /**
     * Lấy cấu hình để khởi tạo chatbot ava
     */
    const getAiBotConfig = () => {
      return {
        user: {
          //Thông tin người dùng gồm: mã, họ và tên, giới tính
          id: user.user_id,
          name: user.full_name,
          gender: 1, // 0.Unknown 1.Nam 2.Nữ
          avatar: `${window._misaId.baseUrl}/image/getavatar?userId=${user.misa_id}&width=100&height=100`, // bổ sung thông tin avatar nhhoang1 12.07.2024
        },
        //Danh sách các item hiển thị để người dùng chọn khi hiển thị khung chatbot của ava
        //mặc định item này là option, optionGroup hết
        homeMenus: [
          {
            message: 'Hỗ trợ sử dụng phần mềm',
            desc: 'Hướng dẫn sử dụng các tính năng của phần mềm',
          },
          {
            message: 'Thực hiện nhanh chức năng',
            desc: 'Lập tờ khai, thêm chứng từ/danh mục,...',
          },
          {
            message: 'Xem nhanh số liệu, báo cáo',
            desc: 'Cung cấp các số liệu hoạt động, xem các báo cáo',
            hasClearLine: true,
          },
        ],
        //Khai báo các chuyên mục tương ứng với homeMenus phía trên, việc dự án sử dụng chuyên mục nào là đã trao đổi với nhóm AI để cấu hình chatbot bên đó
        category: {
          help: ['Hỗ trợ sử dụng phần mềm'],
          function: ['Thực hiện nhanh chức năng'],
          report: ['Xem nhanh số liệu, báo cáo'],
        },
      };
    };
    /**
     * Lấy cấu hình để khởi tạo chatbot ava
     * Custom riêng theo dự án ( ẩn hiện các chức năng đang làm )
     * pntoan 19.4.2024
     */
    const customAiBotConfig = config => {
      // Chỉ hiển thị những chức năng cần thiết
      const optionDisplays = ['chatbot', 'report', 'command'];
      config.avaConfig = Array.from(config.avaConfig).filter(e => optionDisplays.includes(e.FeatureCode));
    };
    /**
     * Cho dự án override để custom nội dung
     */
    const customBotChatRender = (item, botChat) => {
      if (item.type == 'function_calling' && item?.message?.name) {
        let msg = 'Free text để không nhảy theo hàm base';
        let isSaveFncCalling = true;

        switch (item?.message?.name) {
          case 'budget_plan_report':
            budget_plan_report(msg, item.message.params, botChat);
            break;
          case 'cash_payment_receipt_report':
            cash_payment_receipt_report(msg, item.message.params, botChat);
            break;
          case 'show_unit_options':
            show_unit_options(msg, item.message.params, botChat);
            isSaveFncCalling = false;
            break;
          case 'show_cash_grid_detail':
            show_cash_grid_detail(msg, item.message.params, botChat);
            break;
          case 'reset_param':
            reset_form_param(msg, item.message.params, botChat);
            break;
          case 'change_unit':
          case 'change_not_budget_item':
          case 'input_form_param':
            change_property(msg, item.message.params, botChat);
            break;

          // thêm danh mục cán bộ
          case 'quick_add_dic_accounting_object':
            quick_add_dic_accounting_object(msg, item.message.params, botChat);
            break;
          // thêm danh mục TK NH, KB
          case 'quick_add_dic_bank_info':
            quick_add_dic_bank_info(msg, item.message.params, botChat);
            break;
          // thêm danh mục nguồn
          case 'quick_add_dic_budget_source':
            quick_add_dic_budget_source(msg, item.message.params, botChat);
            break;

          // tính hao mòn tscđ
          case 'depreciation_fixed_assets':
            depreciation_fixed_assets(msg, item.message.params, botChat);
            break;

          // kết chuyển nhanh
          case 'quick_transfer_account':
            quick_transfer_account(msg, item.message.params, botChat);
            break;

          // kết chuyển hoạt động sự nghiệp
          case 'create_transfer_activity':
            create_transfer_activity(msg, item.message.params, botChat);
            break;

          // kết chuyển cuối năm
          case 'create_transfer_closing':
            create_transfer_closing(msg, item.message.params, botChat);
            break;

          // kết chuyển chênh lệch thu, chi ngân sách xã
          case 'create_transfer_receipt_clear':
            create_transfer_receipt_clear(msg, item.message.params, botChat);
            break;

          // kết chuyển chênh lệch thu, chi ngân sách xã trong tgian chỉnh lý
          case 'create_transfer_receipt_clear_month13':
            create_transfer_receipt_clear_month13(msg, item.message.params, botChat);
            break;

          // kết chuyển chi ns cuối năm
          case 'create_transfer_begining':
            create_transfer_begining(msg, item.message.params, botChat);
            break;

          // kết chuyển kết dư sang thu ngân sách xã
          case 'create_transfer_budget_balance':
            create_transfer_budget_balance(msg, item.message.params, botChat);
            break;

          default:
            isSaveFncCalling = false;
            return null;
        }

        if (isSaveFncCalling) {
          window._aiBot.handleSaveFncCalling(); // Lưu lại hàm gọi (tích hợp lịch sử và phiên chat)
        }
        return msg;
      }
      const message = item?.message ? item.message.toLowerCase() : '';
      if (message.contains('xin lỗi quý khách')) {
        let item = {
          message: 'Em chưa hiểu rõ vấn đề trên. Quý khách vui lòng mô tả lại giúp em được không ạ?',
        };
        window._aiBot.renderBotChatText(item, botChat);
        return 'fake message';
      }

      return null;
    };

    /**P
     * Cho dự án custom lại giá trị item hiển thị
     * vqphong - 21/11/2024
     */
    const customItemRenderQuickReplies = (newItem, data, botChat) => {
      if (!newItem.message) return null;
      return newItem;
    };

    /**
     * Xử lý vào 1 item chat
     * @param {*} item : dữ liệu render của item
     * @param {*} el (optional) : element click
     */
    const itemClick = (item, el) => {
      const me = window._aiBot;
      let afterEl = null;
      if (el) {
        if (item.optionGroup) {
          //ẩn toàn bộ các el cùng option đi
          //Xóa các gợi ý đi
          function fnRemove(curEl, method) {
            let nex = curEl[method]();
            let source = nex.data('source');
            if (source && source.optionGroup) {
              fnRemove(nex, method);

              nex.remove();
            }
          }

          fnRemove(el, 'next');
          fnRemove(el, 'prev');
          // el.remove();
          // } else if (item.option) {
          //   //ẩn el hiện tại đi
          //   el.remove();
        }

        //trước khi xóa item hiện tại sẽ đánh dấu vị trí render của nội dung mới
        afterEl = el.prev();

        //xóa item hiện tại
        if (!item.notRemoveOption) {
          if (
            el.parentsUntil('.aib-row-mess').parent().length &&
            el.parentsUntil('.aib-row-mess').parent()[0].className == 'aib-row-mess' &&
            !(el[0].className == 'aib-bot-chat-list-group-item' && el.parent().children().length > 1)
          ) {
            // Tìm đến thằng cha để xóa
            // Để ko bị ăn style margin top 8px
            el = el.parentsUntil('.aib-row-mess').parent();
          }
          el.remove();
        }
      }

      let action = item.action;
      if (action) {
        //nếu có định nghĩa action thì sẽ xử lý riêng, còn không thì sẽ xử lý mặc định là sinh câu hỏi thay cho người dùng phải gõ
        if (typeof action.fn === 'function') {
          //trigger call method đã gán vào action
          action.fn(item.FeatureName, item);
          return;
        }

        //xử lý render
        me.renderBotChat(action, afterEl);

        //cập nhật category
        me.updateCategory(item.FeatureName);
      } else {
        me.submitChat(item.textUserChat || item.FeatureName || item.message, item.valueSubmit || item.message);
      }
    };

    /**
     * custom lại quick replies trên phần mềm
     * vqphong - 04/04/2025
     */
    const handleCustomQuickReplies = (item, botChat) => {
      // nếu có kết nối QLTS thì ẩn quick replies
      if (dbOptionStore?.state?.UseQLTSVN && item?.payload?.length) {
        item.payload = item.payload.filter(e => !e.value.includes('depreciation_fixed_assets'));
      }
    };

    return {
      mainStyle,
      width,
      height,
      hideAVAIcon,
      isShowAVAIcon,
      show,
      cash_payment_receipt_report,
      budget_plan_report,
      show_unit_options,
      quick_add_dic_accounting_object,
      quick_add_dic_bank_info,
      quick_add_dic_budget_source,
      depreciation_fixed_assets,
      quick_transfer_account,
      create_transfer_activity,
      create_transfer_closing,
      create_transfer_receipt_clear,
      create_transfer_receipt_clear_month13,
      create_transfer_begining,
      create_transfer_budget_balance,
    };
  },
};
</script>

<style lang="scss">
.aib-bc-msg {
  margin-bottom: 8px !important;
}
.ava-table {
  border-collapse: collapse;
  width: 100%;

  .text-right {
    text-align: right;
  }
  .text-left {
    text-align: left;
  }
  .parent {
    font-weight: 700;
  }
  th {
    background: #e5e5e5;
    border: 1px solid #c1c4cc;
    padding: 8px;
  }
  td {
    border: 1px solid #c1c4cc;
    padding: 8px;
  }
}
#ava-in-noti {
  background: none !important;
  .ava-icon-img {
    background: none !important;
  }
}
.ava-bamboo-chart-title {
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
}
.not-get-budget-item {
  justify-content: center;
  margin-bottom: 8px;
  input {
    margin-right: 6px;
  }
}
.ava-icon {
  z-index: 10;
  user-select: none;
  background: #0f67c5;
  border-radius: 50%;
  cursor: pointer;
  padding: 0px 3px;
  filter: drop-shadow(0 0 6px grey);
  .ava-icon-img-container {
    height: 54px;
    width: 50px;

    display: flex;
    align-items: center;
    justify-content: center;

    .ava-icon-img {
      background: url('/src/assets/images/avaFlatform/logo_ava_v3.svg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      width: 40px;
      height: 40px;
    }
  }

  .ava-content {
    position: relative;
  }
  .off-ava-btn {
    position: absolute;
    top: -3px;
    right: -5px;
    background: #fff;
    height: 17px;
    width: 17px;
    border-radius: 50%;
    z-index: 20;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }
}
</style>
